module.exports = __webpack_public_path__ + "img/international.d9677a3c.svg";